import { render, staticRenderFns } from "./DicomAnnotation.vue?vue&type=template&id=b06c2b4a&scoped=true&"
import script from "./DicomAnnotation.vue?vue&type=script&lang=js&"
export * from "./DicomAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./DicomAnnotation.vue?vue&type=style&index=0&id=b06c2b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c2b4a",
  null
  
)

export default component.exports